"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("../appointment-schedule.constants.js"),i=(t,n)=>t*((n?e.EXTENDED_COLUMN_WIDTH:e.COLUMN_WIDTH)+e.COLUMN_MARGIN*2);exports.getMinHeaderWidth=i;
